export default (store) => {
    if (store.state.pusher && _.isUndefined(store.state.pusher.unsubscribe) && _.isFunction(store.state.pusher.unsubscribe)) {
        store.state.pusher.unsubscribe('user-id-' + store.state.loggedin.profile.id);
        store.state.pusher.unsubscribe('company-id-' + store.state.company.id);
    }
};



// WEBPACK FOOTER //
// ./src/app/store/users/actions/disable-notifications.js